// extracted by mini-css-extract-plugin
export default {"deviceGroupLabel":"assign-device__deviceGroupLabel","transfer":"assign-device__transfer"};